import { isLoading, Loading } from "../loading";
import { useAllTaskTypes } from "./useTaskTypes";
import { Task } from "../types/Task";
import { removeMediaArticlesAfterComplete } from "./useAfterComplete.helper";
import { useRedirect } from "./useRedirect";

export const useAfterComplete = (
  task: Record<string, unknown> | undefined | Loading
): (() => void) => {
  const { data: taskTypes, isLoading: isTaskTypesLoading } = useAllTaskTypes();
  const redirect = useRedirect();

  const afterComplete = taskTypes?.find(
    (type) => type.id === (task as Task)?.task_type_id
  )?.after_complete;

  if (
    isLoading(task) ||
    isTaskTypesLoading ||
    !afterComplete ||
    task === undefined
  ) {
    return () => {};
  }

  const executeAfterComplete = async () => {
    const { id, props } = afterComplete;

    switch (id) {
      case "redirect": {
        redirect(props.url, props.openNewTab);
        return;
      }

      case "remove-media-articles":
        await removeMediaArticlesAfterComplete(task, props);
        return;
      default:
        return;
    }
  };

  return executeAfterComplete;
};
